export const SET_CORPORATE = 'Set corporate'
export const DELETE_CORPORATE = 'Delete corporate'
export const UPDATE_CORPORATE = 'Update corporate'
export const SET_DEPENDENT = 'Set dependent'
export const UPDATE_DEPENDENT = 'Update dependent'
export const CURRENT_DEPENDENT = 'Current dependent'